
import { useTranslation } from "react-i18next";

interface GroupStatusBannerProps {
  status: string;
}

export const GroupStatusBanner = ({ status }: GroupStatusBannerProps) => {
  const { t } = useTranslation();
  
  if (status !== 'archived') return null;
  
  return (
    <div className="p-3 rounded-lg bg-[#5770fd]/10 border border-[#5770fd]/20 text-center">
      <p className="text-sm text-[#5770fd] dark:text-[#5770fd]/90 font-medium">
        {t('groups.archived')}
      </p>
    </div>
  );
};
